import { Box } from '@chakra-ui/react'
import React from 'react'

const ViewportBox = props => <Box height={'100vh'} {...props}/>

export default ViewportBox
